/* eslint-disable */
export enum TripStatusFilter {
  ALL = 0,
  NEW,
  PENDING,
  ACCEPTED,
}
